import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import {
  create_stream,
} from '../script';
import { replace } from 'react-router';

export default function StreamModal(props) {
  const navigate = useNavigate();
  const [createStreamType, setCreateStreamType] = useState("public");

  function handleStreamTypeChange(event) {
    setCreateStreamType(event.target.value);
  }

  function getUserList(id) {
    let user_input = document.getElementById(id);
    let user_list = [];
    if (user_input.value) {
      let emails = user_input.value.split(",");
      for (let i = 0; i < emails.length; i++) {
        let input = emails[i].trim();
        if (input != "") {
          user_list.push(input);
        }
      }
    }
    return user_list;
  }

  async function publicOnClick(event) {
    let stream_title = document.getElementById("input-stream-name").value;
    if (stream_title != null && stream_title != "") {
      // Else create stream
      let stream_id = await create_stream(stream_title);
      // Redirect to streams
      navigate("/s/" + stream_id, { replace: true });
    } else {
      alert("Please enter stream name");
    }
  }

  async function captureUsersAndCreateStream() {
    let stream_title = document.getElementById("input-stream-name").value;

    let users = getUserList("private-users");
    if (users.length == 0) {
      alert("Private streams must have at least one additional user added")
    } else { // Else create stream
      let stream_id = await create_stream(stream_title, "private", users);
      // Redirect to streams
      navigate("/s/" + stream_id, { replace: true });
    }
  }

  async function privateOnClick(event) {
    let stream_title = document.getElementById("input-stream-name").value;

    if (stream_title != null && stream_title != "") {
      captureUsersAndCreateStream();
    } else {
      alert("Please enter stream name");
    }
  }

  async function captureUsersAndCreateSourceStream() {
    let stream_title = document.getElementById("input-stream-name").value;

    let users = getUserList("source-users");
    if (users.length == 0) {
      alert("Source streams must have at least one additional user added")
    } else { // Else create stream
      let context = document.getElementById("source-context").value;
      if (!context){
        alert("Source streams must have context")
      } else { 
        console.log(users)
        console.log(context)
        let stream_id = await create_stream(stream_title, "private", users, context);
        // Redirect to streams
        navigate("/s/" + stream_id, { replace: true });
      }
    }
  }

  async function sourceOnClick(event) {
    let stream_title = document.getElementById("input-stream-name").value;

    if (stream_title != null && stream_title != "") {
      captureUsersAndCreateSourceStream();
    } else {
      alert("Please enter stream name");
    }
  }

  async function handleStreamCreation(event) {
    switch (createStreamType) {
      case "public":
        publicOnClick(event);
        break;
      case "private":
        privateOnClick(event);
        break;
      case "source":
        sourceOnClick(event);
        break;
      default: return
    }
  }

  return (
    <Modal show={props.showModal} onHide={() => props.setShowModal(false)}>
      {/* Modal for creating new streams */}
      <Modal.Header closeButton>
        <Modal.Title>Create Stream</Modal.Title>
      </Modal.Header>
      <Modal.Body className='stream-modal'>
        <Form.Label className="modal-field" htmlFor="input-stream-name"><h6>Enter stream name:</h6></Form.Label>
        <Form.Control
          className="modal-field"
          type="text"
          id="input-stream-name"
        />
        <br />
        <h6 className="modal-field">Choose stream type:</h6>
        <div className='modal-field' style={{ flexDirection: 'column' }}>
          <Form.Check>
            <Form.Check.Input
              id="publicRadio"
              type="radio"
              value='public'
              onChange={handleStreamTypeChange}
              checked={createStreamType === "public"}
            />
            <Form.Check.Label for="publicRadio"><b>Public</b> streams do not expire, and can be viewed by anonymous users. Users must log in to create or join public streams</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input
              id="privateRadio"
              type="radio"
              value='private'
              onChange={handleStreamTypeChange}
              checked={createStreamType === "private"}
            />
            <Form.Check.Label for="privateRadio"><b>Private</b> streams and are only visible to users added when the stream is created</Form.Check.Label>
          </Form.Check>
          <div style={{
            marginLeft: "30px",
            paddingLeft: "20px",
            borderLeft: "1px solid black",
            overflow: "hidden",
            transform: createStreamType === "private" ? "scaleY(1)" : "scaleY(0)",
            height: createStreamType === "private" ? "auto" : "0px",
            transformOrigin: "top",
            transition: "transform 0.26s ease"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center"
            }}>
              <div style={{
                overflow: "hidden",
                transformOrigin: "top",
                transition: "transform 0.26s ease",
                width: "100%"
              }}>
                <input id="private-users" placeholder="Please enter user emails as a comma seperated list" className="stream-table-center" style={{ padding: "10px", fontSize: "16px", border: "1px solid #888", borderRadius: "5px", width: "100%" }} />
              </div>
            </div>
          </div>
          <Form.Check>
            <Form.Check.Input
              id="sourceRadio"
              type="radio"
              value='source'
              onChange={handleStreamTypeChange}
              checked={createStreamType === "source"}
            />
            <Form.Check.Label for="sourceRadio"><b>Source</b> streams query against the provided context are only visible to users added when the stream is created.</Form.Check.Label>
          </Form.Check>
          <div style={{
            marginLeft: "30px",
            paddingLeft: "20px",
            borderLeft: "1px solid black",
            overflow: "hidden",
            transform: createStreamType === "source" ? "scaleY(1)" : "scaleY(0)",
            height: createStreamType === "source" ? "auto" : "0px",
            transformOrigin: "top",
            transition: "transform 0.26s ease"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center"
            }}>
              <div style={{
                marginTop: "10px",
                overflow: "hidden",
                transformOrigin: "top",
                transition: "transform 0.26s ease",
                width: "100%"
              }}>
                <input id="source-users" placeholder="Please enter user emails as a comma seperated list" className="stream-table-center" style={{ padding: "10px", fontSize: "16px", border: "1px solid #888", borderRadius: "5px", width: "100%" }} />
                <input id="source-context" placeholder="Please enter stream context" className="stream-table-center" style={{ marginTop: "10px", padding: "10px", fontSize: "16px", border: "1px solid #888", borderRadius: "5px", width: "100%" }} />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={e => props.setShowModal(false)} variant="secondary">Cancel</Button>
        <Button onClick={e => handleStreamCreation(e)} variant="primary">Create</Button>
      </Modal.Footer>
    </Modal>
  );
}